export enum DeviceStatus {
  ONLINE = 'online',
  OFFLINE = 'offline'
}